 export const environmentalURL = "https://taweb.transactionanalysts.com/taapi";


// export const environmentalURL = "http://localhost:8095/taapi";
